export enum YmGoalSearcher {
  AddToCartButtonClick = 'searcherAddToCartButtonClick',
  ShowCannotPreorderModal = 'searcherShowCannotPreorderModal',
}
